import { render, staticRenderFns } from "./InputCharCounter.vue?vue&type=template&id=13516f73&"
import script from "./InputCharCounter.vue?vue&type=script&lang=js&"
export * from "./InputCharCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports